// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"9d999876","271":"dcef5ebd","453":"2de573ac","664":"5c6cf1d6","750":"6404066a","945":"013068ce"}[chunkId] + ".chunk.js";
};